import React from 'react';
import _ from 'lodash';
import styles from './FeaturesCarouselItem.module.scss';
import { Text } from '@tme/toyota-common';
import { FeaturesAndCapabilitiesResponsePayloadService } from '../../@types/dataTypes';
import FeaturesTreeAccordion from '../featuresTreeAccordion/FeaturesTreeAccordion';
import { determineLabelWithTermUnit } from '../../tools/tools';
import { VinCheckerCSFeaturesLabels } from '../../@types/labelTypes';

type FeaturesCarouselItemProps = {
	service: FeaturesAndCapabilitiesResponsePayloadService;
	labels: VinCheckerCSFeaturesLabels;
};

export default function FeaturesCarouselItem({
	service,
	labels
}: FeaturesCarouselItemProps): React.JSX.Element {
	return (
		<div className={`${styles.featureTreeWrapper}`}>
			<div className={styles.featureTreeTitleContainer}>
				<Text
					kind={`PARAGRAPH`}
					className={`${styles.featureTreeTitle} ${
						service.productType
							? styles.titleWithTrialEligibility
							: styles.titleWithoutTrialEligibility
					}`}
					testId={`${service.serviceName}-service-name-title`}
				>
					{service.serviceName}
				</Text>
				{service.productType && (
					<Text
						kind={`CAPTION`}
						className={`${styles.featureTreeTrialEligibility}`}
						testId={`${service.serviceName}-service-name-eligibility`}
					>
						{service.termUnit &&
						service.term &&
						service.productType.toLowerCase() === `trial`
							? `(${determineLabelWithTermUnit(
									labels.trialEligibility,
									service.termUnit,
									service.term
							  )})`
							: `(${labels.paidSubscription})`}
					</Text>
				)}
			</div>
			<div className={`${styles.featureList}`}>
				{_.map(service.category, (cat) => {
					return (
						<FeaturesTreeAccordion
							category={cat}
							key={`${cat.categoryName}-accordion-item`}
						/>
					);
				})}
			</div>
		</div>
	);
}
